<template>
  <div class="grid-container">
    <div class="grid-row">
      <RelacionClienteInmobiliarioGrid :id-inmueble="props.inmuebleId" :tipo-relacion="TipoRelacionClienteInmobiliarioEnum.Propietario" @nuevaVenta="handleNuevaVenta" />
    </div>
  </div>
</template>

<script setup lang="ts">
import RelacionClienteInmobiliarioGrid from '@/components/relacion-cliente-inmobiliario/RelacionClienteInmobiliarioGrid.vue';
import { TipoRelacionClienteInmobiliarioEnum } from '@api/api';

const emit = defineEmits(['nuevaVenta']);

const props = defineProps({
  inmuebleId: {
    type: String,
    required: true
  }
});

const handleNuevaVenta = () => {
  emit('nuevaVenta');
}
</script>

<style lang="scss" scoped>
</style> 